import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';

export const TextDescription: CSSObject = {
  textTransform: 'capitalize',
};

export const RunnerDetails: CSSObject = {
  color: 'alpha.500',
};

export const RunnerDescription: CSSObject = {
  color: 'gray.400',
};

export const HeaderSvg: CSSObject = {
  borderRadius: 'full',
  bg: 'transparent',
  color: 'alpha.500',
  boxSize: '8',
  p: '1',
};

export const BetMultiIcon: CSSObject = {
  bg: 'transparent',
  boxSize: '10',
  color: 'alpha.500',
  p: '1',
};

export const BetReturn = (status: TBetReturn): CSSObject => ({
  bg: () => {
    switch (status) {
      case 'won':
        return 'green.400';
      case 'lost':
        return 'alpha.900';
      case 'pending':
        return 'beta.400';
      case 'voided':
        return 'alpha.700';
      default:
    }
  },
  color: () => {
    switch (status) {
      case 'won':
        return 'white';
      case 'lost':
        return 'alpha.100';
      case 'pending':
        return 'beta.600';
      case 'voided':
        return 'alpha.400';
      default:
    }
  },
});

export const BetOdds: CSSObject = {
  color: 'gray.700',
};

export const TextBarrierNumber: CSSObject = {
  color: 'alpha.500',
};
